/** Staff-facing labels. Stored API enums stay unchanged. */

export const DEAL_STATUS_LABELS = {
  approval_pending: 'Pending',
  credit_pending: 'Pending',
  approved: 'Approved',
  ready_to_close: 'Ready to Close',
  closing: 'Closing',
  funded: 'Funded',
  delivered: 'Delivered',
  filed_taxes: 'Filed Taxes',
  archived: 'Archived',
};

export const getDealStatusLabel = (status) => {
  if (!status) return 'Unknown';
  if (DEAL_STATUS_LABELS[status]) return DEAL_STATUS_LABELS[status];
  return String(status).replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
};

export const LEAD_TYPE_LABELS = {
  contact: 'Contact',
  vehicle_inquiry: 'Vehicle Inquiry',
  financing: 'Financing',
  trade_in: 'Trade-In',
  prequalification: 'Pre-Qualification',
  chatbot: 'Chatbot',
};

export const getLeadTypeLabel = (type) => LEAD_TYPE_LABELS[type] || type;

export const SERVICE_STATUS_LABELS = {
  pending: 'Pending',
  scheduled: 'Scheduled',
  completed: 'Completed',
};

export const getServiceStatusLabel = (status) => {
  if (!status) return 'Unknown';
  if (SERVICE_STATUS_LABELS[status]) return SERVICE_STATUS_LABELS[status];
  return String(status).replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
};
